const trustItems = [
  { icon: 'ri-shield-check-line', value: '16+', label: 'Years of Experience' },
  { icon: 'ri-star-fill', value: '5.0 ★', label: 'Google Rated' },
  { icon: 'ri-loop-left-line', value: '60%+', label: 'Repeat & Referral' },
  { icon: 'ri-calendar-check-line', value: '7 Days', label: 'A Week' },
  { icon: 'ri-verified-badge-line', value: '100%', label: 'Satisfaction Guaranteed' },
];

export default function TrustBar() {
  return (
    <section className="bg-[#141210] border-b border-white/8">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-5">
        <div className="flex flex-wrap items-center justify-center lg:justify-between gap-y-5 gap-x-4">
          {trustItems.map((item, i) => (
            <div key={i} className="flex items-center gap-3">
              <span className="w-9 h-9 flex items-center justify-center border border-[#BF9448]/30 rounded-sm flex-shrink-0">
                <i className={`${item.icon} text-[#BF9448] text-base`}></i>
              </span>
              <div>
                <div className="font-sans text-white text-sm font-semibold leading-tight tracking-wide">
                  {item.value}
                </div>
                <div className="font-sans text-white/40 text-[11px] tracking-wider">
                  {item.label}
                </div>
              </div>
              {i < trustItems.length - 1 && (
                <div className="hidden xl:block w-px h-8 bg-white/12 ml-4" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
